import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import {
  useDeleteInventoryManager,
  useRestoreInventoryManager
} from "../../../apis";
import { ChangeInventoryManagerDeleteModalProps } from "./ChangeInventoryManagerDeleteModal.types";

import styles from "./ChangeInventoryManagerDeleteModal.module.scss";

const ChangeInventoryManagerDeleteModal = ({
  isOpen,
  id,
  action,
  onClose
}: ChangeInventoryManagerDeleteModalProps) => {
  const restoreInventoryManager = useRestoreInventoryManager({
    onSuccess: () => {
      onClose();
      toast.success(t("Inventory manager restored successfully"));
    }
  });

  const deleteInventoryManager = useDeleteInventoryManager({
    onSuccess: () => {
      onClose();
      toast.success(t("Inventory manager deleted successfully"));
    }
  });

  const onOkClick = () => {
    if (action === "Delete") {
      deleteInventoryManager.mutate(id);
    } else {
      restoreInventoryManager.mutate(id);
    }
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={t(`${action} Manager`)}
      isLoading={
        deleteInventoryManager.isLoading || restoreInventoryManager.isLoading
      }
      okText={action}
      onOk={onOkClick}
      contentClassName={styles.deleteManagerModal}
      onClose={onClose}
    >
      <p className={styles.deleteManagerModal_text}>
        {t(
          `Are you sure you want to ${action.toLowerCase()} this inventory manager?`
        )}
      </p>
    </Modal>
  );
};

export default ChangeInventoryManagerDeleteModal;
